import { observer } from "mobx-react-lite";

import {
  FontSizes,
  NoDataTile,
  Stack,
  Text,
  useFormContext,
  useTheme
} from "@bps/fluent-ui";
import { isDeepEmpty } from "@libs/utils/isDeepEmpty.utils.ts";

import { ApptinfoFilterType } from "./AppointmentInformationModalInner.tsx";
import { PrefAndInformationPivotTabTypes } from "./AppointmentInformationPivotTabs.types.ts";

interface AppointmentInformationTableNoResultsProps {
  selectedTab: PrefAndInformationPivotTabTypes;
}

export const AppointmentInformationTableNoResults = observer(
  ({ selectedTab }: AppointmentInformationTableNoResultsProps) => {
    const theme = useTheme();

    const {
      actions: { reset },
      state: { values }
    } = useFormContext<ApptinfoFilterType>();

    if (!isDeepEmpty(values)) {
      return (
        <Stack
          grow
          verticalFill
          horizontalAlign="center"
          verticalAlign="center"
          styles={{
            root: {
              padding: 8,
              height: "300px",
              fontSize: FontSizes.size14,
              fontStyle: "italic"
            }
          }}
        >
          <NoDataTile
            textProps={{ text: "0 matches found" }}
            linkProps={{
              text: "Clear filters",
              onClick: () => reset({})
            }}
            showBoxShadow={false}
          />
        </Stack>
      );
    }

    return (
      <Stack
        grow
        verticalFill
        tokens={{ childrenGap: 20 }}
        horizontalAlign="center"
        verticalAlign="center"
        styles={{
          root: {
            padding: 8,
            height: 300,
            fontSize: FontSizes.size14,
            fontStyle: "italic"
          }
        }}
      >
        <Text
          styles={{
            root: {
              color: theme.palette.neutralSecondary
            }
          }}
        >
          {selectedTab === PrefAndInformationPivotTabTypes.Upcoming
            ? "No upcoming appointments"
            : "No past appointments"}
        </Text>
      </Stack>
    );
  }
);
